const FIELDS = [
  ["best_for", "Best for"], ["business_model", "Business model"], ["typical_customer", "Typical customer"],
  ["speed_to_market", "Speed to market"], ["recurring_revenue_potential", "Recurring revenue potential"], ["technical_difficulty", "Technical difficulty"],
];

export const CommercialHeader = ({ header, className = "" }) => {
  if (!header) return null;
  return (
    <section className={`border border-purple-500/30 bg-[#06040b] p-5 md:p-6 ${className}`} data-testid="commercial-track-header">
      <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-purple-300">Commercial track header</div>
      <dl className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-3">
        {FIELDS.map(([k, label]) => header[k] && (
          <div key={k} data-testid={`commercial-header-${k.replace(/_/g, "-")}`}>
            <dt className="text-[10px] uppercase tracking-widest text-zinc-500">{label}</dt>
            <dd className="mt-1 text-sm leading-snug text-zinc-200">{header[k]}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
};
